import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import LogoHeader from "../../components/app/headers/LogoHeader";
import Navbar from "../../components/app/navbars/Navbar";
import ErrorBlock from "../../components/error/ErrorBlock";
import ScrollableLayout from "../../components/layout/ScrollableLayout";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/ui/Button";
import { IconHome2 } from "@tabler/icons-react";
import { useHasDesktopSidebar } from "../../components/app/layout/AppLayout";

export default function Error404Page() {
  const { t } = useTranslation();
  const location = useLocation();
  const hasDesktopSidebar = useHasDesktopSidebar();

  useEffect(() => {
    console.error(
      `[404] Page ${location.pathname}${location.search}${location.hash} not found`
    );
  }, [location]);

  return (
    <ScrollableLayout
      // The desktop sidebar already shows the logo.
      header={hasDesktopSidebar ? null : <LogoHeader />}
      footer={<Navbar />}
    >
      <div className="flex flex-col min-h-full">
        <ErrorBlock
          title={t("No fruits found")}
          message={t("This page does not exist. Please try again later.")}
          action={
            <Link to="/discovery">
              <Button
                variant="outline"
                type="button"
                className="[&_svg]:size-7"
              >
                <IconHome2 /> {t("Return to home page")}
              </Button>
            </Link>
          }
        />
      </div>
    </ScrollableLayout>
  );
}
